import React from "react";
import { FormControl, MenuItem, Select, InputLabel, SelectProps, FormControlProps, FormHelperText } from "@material-ui/core";
import { Membership } from "api/memberships";
import { Club } from "api/clubs";
import i18n from "./i18n";

// prop types
interface ClubSelectProps {
    clubFilter?: (club: Club) => boolean,
    clubId?: string,
    controlProps?: FormControlProps,
    helperText?: string,
    customLabel?: string,
    hideAll?: boolean,
    showNone?: boolean,
    memberships: Membership[],
    selectProps?: SelectProps,
    userRoles?: Membership["userRole"][],
    onChange: (clubId?: string) => void,
}

// club select for filters
const ClubSelect = ({ clubFilter, clubId, controlProps, helperText, customLabel, hideAll, showNone, memberships, selectProps, userRoles, onChange }: ClubSelectProps) => (
    <FormControl {...controlProps}>
        <InputLabel>{(customLabel !== undefined ? customLabel : i18n.club)}</InputLabel>
        <Select
            label={i18n.club}
            value={clubId || ""}
            onChange={(e) => onChange((e.target.value as string) || undefined)}
            {...selectProps}
        >
            {showNone && <MenuItem value={undefined}><em>{`(${i18n.none})`}</em></MenuItem>}
            {!hideAll && <MenuItem value=""><em>{`(${i18n.all})`}</em></MenuItem>}
            {memberships.slice()
                .sort((m1, m2) => m1.club.clubName.localeCompare(m2.club.clubName))
                .filter((m) => (userRoles ? userRoles.includes(m.userRole) : true))
                .filter((m) => (clubFilter ? clubFilter(m.club) : true)).map((m) => (
                    <MenuItem key={m.id} value={m.club.id}>{m.club.clubName}</MenuItem>
                ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
);

export default ClubSelect;
